import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';

import { TpslInfo as TimeTriggerTpslProps, tpslModalBunja } from './tpsl-modal-bunja';

export type { TimeTriggerTpslProps };

/**
 * @deprecated Time-trigger orders have been sunset. Kept only for leftover time-trigger TP/SL
 * in the positions table. Do not use for new features — use `useTpslModalOverlay` /
 * `features/src/tpsl-modal` instead.
 */
export function useTimeTriggerTpslModal() {
  const { tpslInfoAtom, isShowAtom, openTpslModal, closeTpslModal } = useBunja(tpslModalBunja);
  const isShow = useAtomValue(isShowAtom);
  const tpSlInfo = useAtomValue(tpslInfoAtom);

  return {
    isShow,
    tpSlInfo,
    onOpenTimeTriggerTpslModal: openTpslModal,
    onCloseTimeTriggerTpslModal: closeTpslModal,
  };
}
